// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"b1d4f162","431":"7f2c3b67","936":"feceadd0"}[chunkId] + ".chunk.css";
};